@if (msfps.getCurrentPreview()) {
  <div class="row">
    <div [class]="msfps.toggleJsonStructure ? 'col-6' : 'col-12'">
      <!-- CCRA kinda individual field preview  -->
      @if (msfps.toggleIndividualSectionFieldPreviewMode) {
        @if (msfps.getCurrentPreview().isQnFieldVisibleOnPreviewArea) {
          <app-label-response-guidance
            [fieldPreview]="msfps.getCurrentPreview()"
          />
        }
      }
      <!-- NIST kinda collective section fields preview -->
      @if (!msfps.toggleIndividualSectionFieldPreviewMode) {
        @for (
          currPreview of msfps.getCurrentPreview() | keyvalue;
          track currPreview
        ) {
          @for (
            fieldPreview of currPreview.value["fieldsList"];
            track fieldPreview
          ) {
            <div [scrollItemIntoView]="fieldPreview?.data?.[0]?.QuestionId">
              @if (fieldPreview.isQnFieldVisibleOnPreviewArea) {
                <app-label-response-guidance [fieldPreview]="fieldPreview" />
              }
            </div>
          }
        }
      }
    </div>
    @if (msfps.toggleJsonStructure) {
      <div class="col-6" style="overflow: scroll">
        <p class="'fw-bold">msfps.getCurrentPreview()</p>
        <pre>{{ msfps.getCurrentPreview() | json }}</pre>
      </div>
    }
  </div>
}
